<template>
  <div>
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
      <h1>Jornalzinho - {{ tituloPromocao }}</h1>
      <b-row class="p-b-20">
        <b-col md="6" xl="6" sm="12">
          <b-button class="btn btn-danger m-w" @click="goBack"
            >Cancelar</b-button
          >
        </b-col>
        <b-col md="6" xl="6" sm="12">
          <b-button
            class="btn btn-success m-w"
            @click="save"
            :disabled="!saveBtn"
            >Salvar</b-button
          >
        </b-col>
      </b-row>

      <b-row v-if="readyToShow">
        <b-col cols="12">
          <b-card header="Editar Imagem" class="mb-2" tag="article">
            <b-row>
              <b-col
                class="mb-4"
                xl="3"
                lg="3"
                md="3"
                sm="3"
                v-for="(prefillImage, index) in prefillImages"
                :key="index"
              >
                <picture-input
                  :ref="pictureInputName(index)"
                  :zIndex="10"
                  :crop="false"
                  :removable="true"
                  margin="16"
                  accept="image/jpeg, image/png"
                  size="10"
                  button-class="changeBtn"
                  removeButtonClass="removeBtn"
                  :custom-strings="{
                    upload:
                      '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                    tap: `${index}<br>Clique aqui para <br> selecionar uma imagem`,
                    drag: `${index}<br>Arraste uma imagem <br> (ou clique aqui)`,
                    change: 'Mudar foto',
                    remove: 'Remover foto',
                  }"
                  :prefill="prefillImage"
                  @change="onChange(prefillImage)"
                >
                </picture-input>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import PictureInput from "vue-picture-input";
import axios from "axios";
import * as config from "@/config.json";
import store from "../../store";

export default {
  name: "editarimagem",
  components: { PictureInput, Loading },
  data: function () {
    return {
      isLoading: false,
      imageSource: null,
      tituloPromocao: null,
      saveBtn: false,
      selecionado: 2,
      readyToShow: false,
      prefillImages: [],
      store,
    };
  },
  methods: {
    pictureInputName(page) {
      return `pictureInput${page}`;
    },
    onChange(image) {
      if (image) {
        this.saveBtn = true;
      } else {
        this.saveBtn = false;
      }
    },
    goBack() {
      localStorage.removeItem("titulo_promocao");
      localStorage.removeItem("url_imagem");
      localStorage.removeItem("image");
      localStorage.removeItem("id_promocao");
      this.$router.go(-1);
    },
    trataImagens() {
      var array = [];

      for (let i = 0; i < this.prefillImages.length; i++) {
        const propName = `pictureInput${i}`;
        const refsImage = this.$refs[propName];
        const base64Image = refsImage[0].image;
        array.push(base64Image);
      }
      return array;
    },
    save() {
      axios
        .post(
          `${config.default.servidor}/gerencial/jornalzinho/imagem`,
          {
            empresaid: localStorage.getItem("enterprise_id").toString(),
            promocaoid: localStorage.getItem("id_promocao").toString(),
            imagem: this.trataImagens(),
          },
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw==",
            },
          }
        )
        .then((response) => {
          if (response.status == 200) {
            let toast = this.$toasted.show("Sucesso!", {
              theme: "toasted-primary",
              position: "bottom-center",
              duration: 5000,
              icon: "check",
              iconPack: "fontawesome",
            });
          } else {
            let toast = this.$toasted.show("Algo deu errado.", {
              theme: "toasted-primary",
              position: "bottom-center",
              duration: 5000,
              icon: "times",
              iconPack: "fontawesome",
            });
          }
          this.goBack();
        })
        .catch((error) => {
          let toast = this.$toasted.show("Algo deu errado.", {
            theme: "toasted-primary",
            position: "bottom-center",
            duration: 5000,
            icon: "times",
            iconPack: "fontawesome",
          });
        });
    },
    async buscarImagens() {
      this.isLoading = true;
      await axios
        .get(
          `${
            config.default.servidor
          }/mobile/retorna-url-jornalzinho/${localStorage
            .getItem("enterprise_id")
            .toString()}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw==",
            },
          }
        )
        .then((response) => {
          if (response.data.data) {
            this.prefillImages = [];
            for (let i = 0; i < response.data.data.length; i++) {
              const e = response.data.data[i] ? response.data.data[i] : null;
              this.prefillImages.push(e != null ? e.split("?")[0] : null);
            }
          }
          if (response.data.data) this.saveBtn = true;
          this.readyToShow = true;
          this.isLoading = false;
        });
    },
  },
  beforeMount() {
    this.buscarImagens();
    this.tituloPromocao = localStorage.getItem("titulo_promocao").toString();
  },
};
</script>